<template>
    <div class="login-container">
        <!-- 背景 -->
        <div id="canvascontainer" ref='can'></div>
        <!-- 登录块 -->
        <el-row style="position: relative; top: 25%;">
            <el-col :span="5" :offset="15" style="background-color: rgba(256,256,256,0.8)">
                <div class="inputdiv">
                    <el-form autoComplete="on" :model="loginForm" :rules="loginRules" ref="loginForm" label-position="left" label-width="0px" class="card-box login-form">
                        <h3 class="title">智能分发中心</h3>
                        <el-form-item prop="username">
                            <span class="svg-container svg-container_login">
                                <svg-icon icon-class="user" />
                            </span>
                            <el-input name="username" type="text" v-model="loginForm.userName" autoComplete="on" placeholder="用户名" />
                        </el-form-item>
                        <el-form-item prop="password">
                            <span class="svg-container">
                                <svg-icon icon-class="password"></svg-icon>
                            </span>
                            <el-input name="password" :type="pwdType" @keyup.enter.native="handleLogin" v-model="loginForm.password" autoComplete="on" placeholder="密码"></el-input>
                            <span class="show-pwd" @click="showPwd">
                                <svg-icon icon-class="eye" />
                            </span>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" class="login-btn" :loading="loading" @click.native.prevent="handleLogin">
                                登录
                            </el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import CryptoJS from 'crypto-js/crypto-js'
import routerUtil from "../../../utils/routerUtil";
import {webLogin} from "@api/center/login";

// 背景必须的参数
let SEPARATION = 100, AMOUNTX = 50, AMOUNTY = 50;
let container;
let camera, scene, renderer;
let particles, particle, count = 0;
let mouseX = 0, mouseY = 0;
let windowHalfX = window.innerWidth / 2;
let windowHalfY = window.innerHeight / 2;
let displayAnimation = true;

export default {
    name: 'login',
    data() {
        return {
	        loginForm:{
        		userName: '',
                password: '',
            },
	        pwdType: 'password',
	        loading: false,
	        loginRules: {
		        userName: [{ required: true, trigger: 'blur', message: '请输入用户名' }],
		        password: [{ required: true, trigger: 'blur', message: '请输入密码' }]
	        },
        }
    },
    mounted() {
        this.showBackground()
    },
    beforeDestroy() {
	    displayAnimation = false;
    },
    methods: {
        /**
         * 加载背景
         */
        showBackground() {
            container = document.createElement('div');
            this.$refs.can.appendChild(container);

            camera = new THREE.PerspectiveCamera(75, window.innerWidth / window.innerHeight, 1, 10000);
            camera.position.z = 1000;
            scene = new THREE.Scene();
            particles = new Array();

            var PI2 = Math.PI * 2;
            var material = new THREE.ParticleCanvasMaterial({
                color: 0x0078de,
                program: function(context) {
                    context.beginPath();
                    context.arc(0, 0, 1, 0, PI2, true);
                    context.fill();
                }
            });

            var i = 0;
            for (var ix = 0; ix < AMOUNTX; ix++) {
                for (var iy = 0; iy < AMOUNTY; iy++) {
                    particle = particles[i++] = new THREE.Particle(material);
                    particle.position.x = ix * SEPARATION - ((AMOUNTX * SEPARATION) / 2);
                    particle.position.z = iy * SEPARATION - ((AMOUNTY * SEPARATION) / 2);
                    scene.add(particle);
                }
            }

            renderer = new THREE.CanvasRenderer();
            renderer.setSize(window.innerWidth, window.innerHeight-4);
            container.appendChild(renderer.domElement);

            document.addEventListener('mousemove', onDocumentMouseMove, false);
            window.addEventListener('resize', onWindowResize, false);
            animate();
        },

        /**
	     * 控制是否显示密码
	     */
	    showPwd() {
		    if (this.pwdType === 'password') {
			    this.pwdType = ''
		    } else {
			    this.pwdType = 'password'
		    }
	    },

	    /**
         * 点击登录
	     */
	    handleLogin() {
		    webLogin(this.loginForm).then(() => {
			    let token = CryptoJS.HmacMD5(this.loginForm.password, this.loginForm.userName);
			    localStorage.setItem("dq_center_li_time",new Date().getTime());
			    localStorage.setItem("dq_center_u_tk",token);
			    routerUtil.loadRouterByMenus();
			    routerUtil.showMenuFirstView();
            });
        },
    },
}

function onWindowResize() {
    windowHalfX = window.innerWidth / 2;
    windowHalfY = window.innerHeight / 2;
    camera.aspect = window.innerWidth / window.innerHeight;
    camera.updateProjectionMatrix();
    renderer.setSize(window.innerWidth, window.innerHeight);
}

function onDocumentMouseMove(event) {
    mouseX = event.clientX - windowHalfX;
    mouseY = event.clientY - windowHalfY;
}

function onDocumentTouchStart(event) {
    if (event.touches.length === 1) {
        event.preventDefault();
        mouseX = event.touches[0].pageX - windowHalfX;
        mouseY = event.touches[0].pageY - windowHalfY;
    }
}

function onDocumentTouchMove(event) {
    if (event.touches.length === 1) {
        event.preventDefault();
        mouseX = event.touches[0].pageX - windowHalfX;
        mouseY = event.touches[0].pageY - windowHalfY;
    }
}

function animate() {
	if (displayAnimation) {
		requestAnimationFrame(animate);
	}
    render();
}

// 渲染
function render() {
    camera.position.x += (mouseX - camera.position.x) * .05;
    camera.position.y += (- mouseY - camera.position.y) * .05;
    camera.lookAt(scene.position);

    var i = 0;
    for (var ix = 0; ix < AMOUNTX; ix++) {
        for (var iy = 0; iy < AMOUNTY; iy++) {
            particle = particles[i++];
            particle.position.y = (Math.sin((ix + count) * 0.3) * 50) + (Math.sin((iy + count) * 0.5) * 50);
            particle.scale.x = particle.scale.y = (Math.sin((ix + count) * 0.3) + 1) * 2 + (Math.sin((iy + count) * 0.5) + 1) * 2;
        }
    }
    renderer.render(scene, camera);
    count += 0.1;
}
</script>

<style rel="stylesheet/scss">
.login-container a {
    color: #0078de;
}

#canvascontainer {
    position: absolute;
}

.login-container {
    width: 100vw;
    height: 100vh;
    background-color: #141a48;
}
</style>

<style rel="stylesheet/scss" lang="scss">
    $dark_gray:#889aa4;
    $light_gray:#eee;

    .login-container {
        height: 100vh;
        input:-webkit-autofill {
            -webkit-box-shadow: 0 0 0px 1000px #E5E5E5 inset !important;
            -webkit-text-fill-color: #293444 !important;
        }
        .contentdiv {
            width: 100%;
            margin: 0 auto 0 auto;
            padding-top: 200px;
            padding-left: 16%;
            padding-right: 20%;
            .logo-div {
                position: absolute;
                top: 12px;
                left: 20px;
                img {
                    float: left;
                    height: 50px;
                }
                span {
                    display: block;
                    float: left;
                    line-height: 50px;
                    margin-left: 24px;
                    color: #fff;
                    font-size: 18px;
                }
            }
            .desc-div {
                float: left;
                width: 44%;
                .desc-title {
                    margin-top: 0px;
                    font-size: 40px;
                    color: #fff;
                }
                .desc-detail {
                    line-height: 30px;
                    letter-spacing: 3px;
                    text-indent: 20px;
                    margin-top: 20px;
                    color: #fff;
                }
            }
            .logindiv {
                margin-left: 44%;
                position: absolute;
            }
        }
        input {
            background: transparent;
            border: 0px;
            -webkit-appearance: none;
            border-radius: 0px;
            padding: 12px 5px 12px 15px;
            height: 47px;
        }
        .el-input {
            display: inline-block;
            height: 47px;
            width: 85%;
        }
        .tips {
            font-size: 14px;
            color: #fff;
            margin-bottom: 10px;
        }
        .svg-container {
            padding: 6px 5px 3px 15px;
            color: $dark_gray;
            vertical-align: middle;
            width: 30px;
            display: inline-block;
            .svg-icon {
                font-size: 20px;
            }
        }
        .svg-container_login {
            .svg-icon {
                font-size: 30px;
                padding-top: 2px;
                margin-left: -6px;
            }
        }
        .title {
            font-size: 26px;
            font-weight: 400;
            color: #30384A;
            margin: 0px auto 40px auto;
            text-align: center;
            font-weight: bold;
        }
        .login-form {
            left: 0;
            right: 0;
            width: 400px;
            padding: 35px 35px 15px 35px;
            background-color: #fff;
        }
        .el-form-item {
            border: 1px solid rgba(255, 255, 255, 0.1);
            background: rgba(0, 0, 0, 0.1);
            border-radius: 5px;
            color: #454545;
            margin-bottom: 30px;
        }
        .show-pwd {
            position: absolute;
            right: 10px;
            top: 7px;
            font-size: 16px;
            color: $dark_gray;
            cursor: pointer;
            user-select: none;
        }
        .thirdparty-button {
            position: absolute;
            right: 35px;
            bottom: 28px;
        }
        .login-btn {
            width: 100%;
            height: 50px;
            font-size: 18px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/view/base/login/index.vue